import { render, staticRenderFns } from "./userPurchaseHistory.vue?vue&type=template&id=dad1b76c&"
import script from "./userPurchaseHistory.vue?vue&type=script&lang=js&"
export * from "./userPurchaseHistory.vue?vue&type=script&lang=js&"
import style0 from "./userPurchaseHistory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports